export default __webpack_public_path__ + "static/char-12-anr-3c985a656eea33f092d06a325dc9324a.webp";